export const managerUsers = {
  usersList: {
    title: "Usuários registrados",
    subtitle: "Lista de usuários registrados na plataforma.",
    columns: {
      id: "ID",
      name: "Nome",
      phone: "Telefone",
      email: "E-mail",
      accommodations: "Acomodações",
      sends: "Envios",
      checkin: "Check-in",
      registeredAt: "Data de registro",
    },
    states: {
      demo: "Versão demo",
      demoEnded: "Demo encerrada",
      subscribed: "Assinante",
      subscriptionExpired: "Assinatura expirada",
      queryError: "Erro na consulta",
    },
    deleteAdvisor: {
      confirmMessage: "Tem certeza de que deseja excluir este consultor?",
      confirmHeader: "Confirmar",
    },
  },
  accommodationUser: {
    info: "Detalhes da acomodação",
  },
  dataUserOld: {
    accommodationsList: "Lista de acomodações",
    createAccommodation: "Criar acomodação",
    emptyMessage: "Nenhuma acomodação registrada",
    emptySubMessage: "As acomodações registradas pelo usuário aparecerão aqui.",
  },
  checkins: {
    title: "Check-ins concluídos",
  },
  checkinsPending: {
    title: "Check-ins pendentes ou em andamento",
  },
};
